import React, { useEffect } from 'react';
import * as css from './ContactDealer.module.scss';
import { strings } from 'src/localization';
import moment from 'moment';
import { VehicleRec, ascClickToCallInput, ascCommSubmissionSvcInput, ascCtaInteractionInput } from 'src/models';
import { ascClickToCall, ascCommSubmissionSvc, ascCtaInteraction, getElementColor } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';

export interface Iprops {
    header: string;
    lines: string[];
    paragraph?: boolean
    times?: boolean
    closures?: boolean
    email?: boolean
    telephone?: boolean
    ext?: string
    locale?: string
    vehicles: VehicleRec[],
    selectedVehicle?: string,
    theme: string,
}

const ContactSection = (props: Iprops) => {
    useEffect(() => {
        if (props.header) {
            const contactCard = document.getElementById('contactSection');
            if (contactCard) {
                contactCard.scrollIntoView(true);
            }
        }
    }, [props]);

    let outputLines: JSX.Element[] | JSX.Element = props.lines.map(line => (
        <div key={line.length.toString() + line.slice(0, 6)} style={{ marginBottom: '0.2rem' }}>{line}</div>));
    const linkClickHandler = (e: any) => {
        let elementText = '';
        if (props.telephone) {
            let commPhoneNumber = props.lines[0];
            if (props.ext) {
                commPhoneNumber = `${props.lines[0]} ${strings.ext} ${props.ext}`;
            }
            elementText = commPhoneNumber;
            const ascClickToCallInp : ascClickToCallInput = {
                pageType: 'contact',
                commPhoneNumber: commPhoneNumber,
                department: 'service',
                affiliation: 'call_source',
            };
            ascClickToCall(ascClickToCallInp, props.vehicles, props.selectedVehicle);
        } else if (props.email) {
            elementText = props.lines[0];
            const ascCommSubmissionSvcInp : ascCommSubmissionSvcInput = {
                pageType: 'contact',
                commType: 'email',
                affiliation: 'native',
                elementPosition: 'left',
                department: 'service',
                affiliationId: '',
                commStatus: 'start',
            };
            ascCommSubmissionSvc(ascCommSubmissionSvcInp, props.vehicles, props.selectedVehicle);
        }
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: elementText,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'item_details',
            elementSubType: 'selection_link',
            eventAction: 'click',
            eventActionResult: 'popup',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    };

    const linkStyles = classNames(
        css.link,
        {
            [css.linkBMW]: props.theme === 'bmw',

        },
    );

    if (props.email || props.telephone) {
        outputLines = props.lines.map(line => (
            <div key={line.length.toString() + line.slice(0, 6)}>
                <a className={linkStyles} onClick={linkClickHandler}
                    href={`${props.email ? 'mailto' : 'tel'}:${line}`}
                    target='hidden-iframe'>{line}
                </a>
                {props.ext && <span>{` ${strings.ext} ${props.ext}`}</span>}
            </div>
        ));
    }

    if (props.paragraph) {
        outputLines = props.lines.map(line => (
            <span key={line.length.toString() + line.slice(0, 6)} className={css.paragraph}>{line}</span>));
    }

    if (props.times) {
        let numberOfTimes = 1;
        for (let i = 0; i < props.lines.length; i++) {
            const line = props.lines[i];
            if (line.split('|').length > numberOfTimes) {
                numberOfTimes = line.split('|').length;
            }
        }

        outputLines = props.lines.map(line => {
            const day = line.split(' ')[0];
            const times = line.split(' ').splice(1);
            let timeCounter = 0;

            let separatorStyle: string = '';
            let timeSepStyle: string = '';
            switch (numberOfTimes) {
                case 1:
                    separatorStyle = css.separatorOne;
                    timeSepStyle = css.timeSepOne;
                    break;
                case 2:
                    separatorStyle = css.separatorTwo;
                    timeSepStyle = css.timeSepTwo;
                    break;
                case 3:
                    separatorStyle = css.separatorThree;
                    timeSepStyle = css.timeSepThree;
                    break;
                default:
                    separatorStyle = css.separatorThree;
                    timeSepStyle = css.timeSepThree;
            }
            const timeElements = times.map(time => {
                timeCounter++;
                if (time === times[0]) {
                    return (<div key={timeCounter}
                        className={css.hours1}>{time}</div>);
                }
                if (time === '-') {
                    return (<div key={timeCounter}
                        className={separatorStyle}>{time}</div>);
                }
                if (time === '|') {
                    return (<div key={timeCounter}
                        className={timeSepStyle}>{time}</div>);
                }

                return (<div key={timeCounter}
                    className={css.hours3}>{time}</div>);
            },
            );

            return (
                <div key={day} className={css.dayTimeContainter}>
                    <span>{day}</span>
                    <span className={css.timesContainer}>{timeElements}</span>
                </div>
            );
        });
    }

    if (props.closures) {
        outputLines = props.lines.map(line => {
            const processingDate = new Date(`${line}`);
            const date = moment.utc(processingDate).locale(props.locale ?? '').format('MMMM D, YYYY');

            return (
                <span key={props.header + processingDate} style={{ marginBottom: '0.2rem' }}>
                    {date}
                </span>
            );
        });
    }

    const contactHeaderStyles = classNames(
        css.contactHeader,
        {
            [css.contactHeaderBMW]: props.theme === 'bmw',
            [css.contactHeaderFord]: props.theme === 'ford',
            [css.contactHeaderIN]: props.theme === 'infiniti',
            [css.contactHeaderAcura]: props.theme === 'acura',
        },
    );

    return (
        <div id='contactSection' className={css.contactSection}>
            <strong className={contactHeaderStyles}>{props.header}</strong>
            {outputLines}
        </div>
    );
};

export default ContactSection;